import ApexCharts from "apexcharts";

import { CellOutcome } from "@components/ChartCapture/types";

export const captureFromChart = async (chart: ApexCharts | null): Promise<CellOutcome> => {
  if (!chart || !chart.getSeriesTotal().length) {
    return { imageUri: null, hasData: false, captured: false, timedOut: false };
  }
  try {
    const blob = (await chart.dataURI()) as { imgURI: string };
    const imageUri = blob.imgURI || null;
    return { imageUri, hasData: true, captured: !!imageUri, timedOut: false };
  } catch (error) {
    console.error("Off-screen chart capture failed", error);
    return { imageUri: null, hasData: true, captured: false, timedOut: false };
  }
};
